import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { CorporateDashboardComponent } from "./corporate/corporate-dashboard/corporate-dashboard.component";
import { HomeComponent } from "./shared-modules/home/home.component";
import { LoginComponent } from "./shared-modules/login/login.component";
import { DownloadComponent } from "./download/download.component";
import { CorporateHomeComponent } from "./shared-modules/corporate-home/corporate-home.component";

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "corporate",
    component: CorporateHomeComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "app-download",
    component: DownloadComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
